var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXdc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 2500 2500",
    style: {
      enableBackground: "new 0 0 2500 2500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#B7B5B1;}\n\t.st1{fill:#244B81;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_2091123833488"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M2500,1131C2213-533,40-211,1,1131c125,65,204,105,204,105s-66,40-205,128c250,1632,2386,1395,2500-2    c-136-83-210-127-210-127S2354,1205,2500,1131z M1431,1712l-204-350l-207,350l-157-11l295-497L892,775l160-14l189,318l189-304    l149,4l-248,422l273,508l-175,4L1431,1712z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M2399,1066C2010-413,225-13,103,1066c248,139,304,172,304,172s-96,61-305,194c266,1422,2191,1148,2297-2    c-194-122-309-193-309-193S2352,1091,2399,1066z M1431,1713l-204-350l-207,350l-156-11l295-497L893,776l160-14l189,318l189-304    l149,4l-247,422l273,508l-175,4V1713z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXdc);
export default __webpack_public_path__ + "static/media/xdc.1c61c09cfc97a7ff96e2787985cb7cc5.svg";
export { ForwardRef as ReactComponent };